import Vue from 'vue'

export const EventBusEvents = {
  showAlert: 'show-alert',
}

const EventBus = new Vue()

export default EventBus
